module.exports = __webpack_public_path__ + "img/steam_store.124bc2a.png";